exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.reference-documents-container{display:flex;flex-direction:column;height:100%;width:100%}.reference-documents-container .reference-documents-body{margin:0 86px;display:flex;flex-direction:column}.reference-documents-container .reference-documents-body .reference-documents-details{position:relative;display:flex;align-items:center;width:calc(100% - 15px);height:70px}.reference-documents-container .reference-documents-body .reference-documents-details .reference-documents-title{font-family:Open Sans,sans-serif;font-style:italic;font-weight:700;width:auto;font-size:24px;color:#2c2c2c}.reference-documents-container .reference-documents-body .reference-documents-details .ref-docs-add-button{margin-left:16px;width:32px;height:32px;background-image:url(" + require("../../assets/images/add-blue-button.svg") + ");background-size:32px 32px;background-repeat:no-repeat;cursor:pointer;transition:transform .2s ease}.reference-documents-container .reference-documents-body .reference-documents-details .ref-docs-add-button--rotated{transform:rotate(45deg);transition:transform .2s ease}.reference-documents-container .reference-documents-body .reference-documents-details .reference-documents-search{width:20%;position:absolute;right:0;top:6px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentsLibrary.scss
// module id = 1836
// module chunks = 0